import { captureMessage } from '@sentry/browser';

const errorLogger = (error) => {
  captureMessage(error);
};

export default errorLogger;
